import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/login/fromEmail')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/login/fromEmail"!</div>
}
